import React from 'react'
import ReactDOM from 'react-dom'
import { Loader } from 'pixi.js'
import Text from './components/Text'
import TextVerify from './components/TextVerify'
import Terminal from './components/Terminal'
import PixiDemo from './components/PixiDemo'
import PixiShader from './components/PixiShader'
import PixiVerify from './components/PixiVerify'
import Loading from './components/Loading'
import Actions from './components/Actions'

import { FLAME } from './components/pixi/shaders'
import { PAGES, RESOURCES } from './definition'

import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './index.scss'

const INTRO_URL =  "https://go.clubon.space/vg_event"

const App = () => {
  const [state, setState] = React.useState({
    progress: 0,
    resources: null,
    pageNum: 0
  })

  React.useEffect(() => {
    let loader = new Loader()
    for (let i = 0; i < RESOURCES.length; i++) {
      let resource = RESOURCES[i]
      loader.add(resource.name, resource.url)
    }
    loader.on("progress", (ldr, res) => {
      setState({...state, progress: ldr.progress})
    })
    .load((ldr, res) => {
      setState({...state, resources: res})
    })
  }, [])

  const handleNext = () => {
    if (state.pageNum + 1 < PAGES.length) {
      setState({...state, pageNum: state.pageNum + 1})
    }
  }

  if (!state.resources) {
    return (
      <div style={{
        height: "inherit",
        backgroundColor: "black",
        textAlign: "center",
      }}>
        <Loading progress={state.progress} />
      </div>
    )
  } else {
    return (
      <PageFlipper
        pages={PAGES}
        pageNum={state.pageNum}
        resources={state.resources}
        onNext={handleNext}
      />
    )
  }
}

const PageFlipper = (props) => {
  const handleInputEmail = () => {
    let input = document.getElementById("input"), formData = new FormData()
    let re = /^[^\s@#!]+@[^\s@.#!]+(.[^\s@.]+)+$/

    if (re.test(input.value)) {
      formData.append("email", input.value)
      input.value = "資料傳輸中..."
      input.style.borderColor = "green"

      fetch("https://script.google.com/macros/s/AKfycbw6FGLu4AnB6Yx9vMdvI0_fGVhEAGiuZPKYeUSPnxOHqbdk0__y/exec", {
        method: 'POST',
        body: formData
      })
      .then(res => props.onNext())
      .catch(err => console.log(err))
    } else {
      input.value = ""
      input.style.borderColor = "red"
    }
  }

  const handleOpenIntro = () => {
    window.open(INTRO_URL, '_blank')
  }

  const renderPage = (page, index) => {
    let images = [], imageKeys = Object.keys(page.images)
    for (let i = 0; i < imageKeys.length; i++) {
      images.push(props.resources[page.images[imageKeys[i]]])
    }
    if (props.pageNum === index) {
      switch(page.type) {
        case "starting":
          return (
            <div style={{
              height: "inherit",
              backgroundColor: "#000000",
              textAlign: "center",
            }}>
              <PixiDemo images={images} entityY={0.3} alpha={page.alpha} />
              <Actions>
                <div className="btn btn-cyan" onClick={props.onNext}>
                  開始遊戲
                </div>
                <div className="btn btn-cyan" onClick={handleOpenIntro}>
                  抽獎辦法
                </div>
               </Actions>
            </div>
          )
        case "ending":
          return (
            <div style={{
              height: "inherit",
              backgroundColor: "#000000",
              textAlign: "center",
            }}>
              <PixiDemo images={images} entityY={0.3} alpha={page.alpha} />
              <div style={{position: "absolute", color: "white", bottom: "25vh", textAlign: "center", width: "100%"}}>
                填寫信箱，案件發生時我們將立刻通知你
              </div>
              <Actions bottom={15}>
                <input
                  id="input"
                  placeholder="Email"
                  style={{width: "60vw", height: "34px", padding: "7px", fontSize: "16px", borderRadius: "0.25rem"}}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) handleInputEmail()
                  }}
                />
                <div
                  className="btn btn-outline-light"
                  style={{padding: "4px 18px", fontSize: "16px"}}
                  onClick={handleInputEmail}
                >
                  送出
                </div>
              </Actions>
              <Actions bottom={5}>
                <div
                  className="btn btn-cyan"
                  style={{fontSize: "3vh"}}
                  onClick={handleOpenIntro}
                >
                  抽獎辦法
                </div>
                <div />
              </Actions>
            </div>
          )
        case "text":
          return (
            <div
              style={{
                height: "inherit",
                backgroundColor: "#000000",
                textAlign: "center",
              }}
            >
              <PixiDemo images={images} alpha={page.alpha}/>
              <Text
                texts={page.texts}
                onEnd={props.onNext}
              />
            </div>
          )
        case "terminal_verify":
          return (
            <div style={{
              height: "inherit",
              backgroundColor: "#000000",
              textAlign: "center",
            }}>
              <PixiDemo images={images} alpha={page.alpha} />
              <Terminal code={page.code} input={page.input} />
              <TextVerify answer="DEATH" onVerify={props.onNext}/>
            </div>
          )
        case "pixi_shader":
          return (
            <div style={{
              height: "inherit",
              backgroundColor: "#EEEEEE",
              textAlign: "center",
            }}>
              <PixiShader images={images} entityY={0.3} shader={FLAME}/>
              <Actions bottom={15}>
                <div style={{color: "red"}}>
                  你能查出真相嗎？
                </div>
                <div>
                </div>
              </Actions>
              <Actions bottom={5}>
                <div className="btn btn-cyan" onClick={() => window.location.reload()}>
                  再玩一次
                </div>
                <div className="btn btn-cyan" onClick={handleOpenIntro}>
                  抽獎辦法
                </div>
                <div className="btn" style={{backgroundColor: "DodgerBlue", padding: "1px 10px", cursor: "pointer", borderRadius: "3px", fontSize: "10px"}} onClick={window.fbShare}>
                  <span className="fab fa-facebook-f" style={{backgroundColor: "white", borderRadius: "50%", width: "12px", height: "12px", color: "DodgerBlue"}} />
                  <span style={{padding: "0 2px", color: "white"}}>分享</span>
                </div>
              </Actions>
            </div>
          )
        case "pixi_verify":
          return (
            <div style={{
              height: "inherit",
              backgroundColor: "#EEEEEE",
              textAlign: "center",
            }}>
              <PixiVerify
                images={images}
                items={page.items}
                answer={page.answer}
                onVerified={props.onNext}
              />
            </div>
          )
        default:
          return (
            <div>{page.type + " page does not exist!"}</div>
          )
      }
    } else {
      return null
    }
  }

  return (
    <React.Fragment>
      {
        props.pages.map((p, i) => (renderPage(p, i)))
      }
    </React.Fragment>
  )
}

ReactDOM.render(
  <App />, document.getElementById('root')
)
